// extracted by mini-css-extract-plugin
export default {"droppable":"droppable-styles_droppable__4Tv4k"};